'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherChevronDown, FeatherChevronUp } from '@subframe/core';
import { Checkbox } from '../Checkbox';
import { Table } from '../Table';
import type { ColumnDef, SortState } from './types';
function SortIcon(t0) {
  const $ = _c(3);
  const {
    sortKey,
    currentSort
  } = t0;
  if (!currentSort || currentSort.key !== sortKey) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <FeatherChevronDown className="h-4 w-4 text-neutral-400 opacity-0 transition-opacity group-hover:opacity-100" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== currentSort.direction) {
    t1 = currentSort.direction === "asc" ? <FeatherChevronUp className="text-brand-600 h-4 w-4" /> : <FeatherChevronDown className="text-brand-600 h-4 w-4" />;
    $[1] = currentSort.direction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
interface DataTableHeaderProps<T> {
  columns: ColumnDef<T>[];
  sort?: SortState;
  onSortChange?: (sort: SortState) => void;
  selectionMode?: 'none' | 'multiple';
  allSelected?: boolean;
  onToggleSelectAll?: () => void;
  hasRowActions?: boolean;
  isLoading?: boolean;
  cellPaddingX?: string;
}
export function DataTableHeader(t0) {
  const $ = _c(29);
  const {
    columns,
    sort,
    onSortChange,
    selectionMode: t1,
    allSelected: t2,
    onToggleSelectAll,
    hasRowActions: t3,
    isLoading: t4,
    cellPaddingX: t5
  } = t0;
  const selectionMode = t1 === undefined ? "none" : t1;
  const allSelected = t2 === undefined ? false : t2;
  const hasRowActions = t3 === undefined ? false : t3;
  const isLoading = t4 === undefined ? false : t4;
  const cellPaddingX = t5 === undefined ? "px-6" : t5;
  let t6;
  if ($[0] !== onSortChange || $[1] !== sort) {
    t6 = col => {
      if (!col.sortable || !onSortChange) {
        return;
      }
      const sortKey = col.sortKey ?? col.id;
      const newDirection = sort?.key === sortKey && sort.direction === "asc" ? "desc" : "asc";
      onSortChange({
        key: sortKey,
        direction: newDirection
      });
    };
    $[0] = onSortChange;
    $[1] = sort;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const handleSortClick = t6;
  let t7;
  if ($[3] !== allSelected || $[4] !== cellPaddingX || $[5] !== isLoading || $[6] !== onToggleSelectAll || $[7] !== selectionMode) {
    t7 = selectionMode === "multiple" && <Table.HeaderCell className={`w-[48px] ${cellPaddingX}`}><div className="flex items-center justify-center"><Checkbox checked={allSelected} onCheckedChange={() => onToggleSelectAll?.()} disabled={isLoading} /></div></Table.HeaderCell>;
    $[3] = allSelected;
    $[4] = cellPaddingX;
    $[5] = isLoading;
    $[6] = onToggleSelectAll;
    $[7] = selectionMode;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== cellPaddingX || $[10] !== columns || $[11] !== handleSortClick || $[12] !== isLoading || $[13] !== onSortChange || $[14] !== sort) {
    let t9;
    if ($[16] !== cellPaddingX || $[17] !== handleSortClick || $[18] !== isLoading || $[19] !== onSortChange || $[20] !== sort) {
      t9 = col_0 => {
        const alignClass = col_0.align === "right" ? "text-right justify-end" : col_0.align === "center" ? "text-center justify-center" : "text-left";
        const isCurrentSort = sort?.key === (col_0.sortKey ?? col_0.id);
        const ariaSort = col_0.sortable ? isCurrentSort ? sort.direction === "asc" ? "ascending" : "descending" : "none" : undefined;
        return <Table.HeaderCell key={col_0.id} aria-sort={ariaSort} className={`${cellPaddingX} ${col_0.width ?? ""} ${col_0.minWidth ?? ""} ${col_0.headerClassName ?? ""}`}>{col_0.sortable && onSortChange ? <button type="button" className={`group flex items-center gap-1 select-none ${alignClass}`} onClick={() => !isLoading && handleSortClick(col_0)} disabled={isLoading}>{col_0.header}{!isLoading && <SortIcon sortKey={col_0.sortKey ?? col_0.id} currentSort={sort} />}</button> : <div className={alignClass}>{col_0.header}</div>}</Table.HeaderCell>;
      };
      $[16] = cellPaddingX;
      $[17] = handleSortClick;
      $[18] = isLoading;
      $[19] = onSortChange;
      $[20] = sort;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = columns.map(t9);
    $[9] = cellPaddingX;
    $[10] = columns;
    $[11] = handleSortClick;
    $[12] = isLoading;
    $[13] = onSortChange;
    $[14] = sort;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[22] !== cellPaddingX || $[23] !== hasRowActions) {
    t9 = hasRowActions && <Table.HeaderCell className={`${cellPaddingX} text-right`}>Ações</Table.HeaderCell>;
    $[22] = cellPaddingX;
    $[23] = hasRowActions;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <Table.HeaderRow>{t7}{t8}{t9}</Table.HeaderRow>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}